import {
    Component, OnInit, ViewChild, ElementRef,
    Input, Output, EventEmitter
} from '@angular/core';
import { NetworkService } from '../network.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VcaAlertsService } from './../../../../../../common/vca-alerts';
import { VcaGrid } from './../../../../../../common/vca-grid/vca-grid.component';
import { NgForm } from '@angular/forms';
import { getIPScopeListingDatatableConfig } from '../dialogs/ipscope.dt.config';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { NetworkConstants } from '../network-constants';
import { Response } from '@angular/http';
const _ = require('lodash');

import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { AssociateVcDialog } from './associate-vc-dialog-component';
var $ = require('jquery');

import { AuthService } from '../../../../../auth/auth.service';

const DEFAULT_ROUTE_ON_COMPLETE:string = 'services/networking/network';

@Component({
    selector: 'add-edit-import-network',
    template: require('./add-edit-import-network-dialog.html'),
    styles: [require('../../networking-view.scss')],
    providers: [
        TranslateService
    ]
})

export default class AddEditImportNetworkDialog {
    @Input() routeOnCompleteOrCancel:boolean = true;
    @Input() routeTo:string = DEFAULT_ROUTE_ON_COMPLETE;
    @Output() onCancel = new EventEmitter<any>();
    @Output() onComplete = new EventEmitter<any>();

    private dataModel = {
        name: '',
        ipScopes: [],
        description: '',
        l3TenantManaged: true, // Internet = false, DC = true, trunk = true, Other NW true
        ownedBySystem: true, // Internet & DC = true, other NW false,
        allowTrunkInterfaces: false,
        enterprise: "DEFAULT",
        backings: []

    };

    private operationMode: number = NetworkConstants.OPERATION_MODE.ADD;
    private typeOfNetwork: number = 1;
    private showModal: boolean = false;
    private subscribeHandler: Subscription;
    private networkTypes: Array<any> = [];
    private computeContainers: Array<any> = [];
    private showIPPoolCreateDialog: boolean = false;
    private openIPScopeDialog: boolean = false;
    private selectedIpScope = { gateway: '', networkIpRanges: [{}] };
    private isRowSelected: boolean = false;
    private selectedIPScopeRowIndex: number = -1;
    private subscribeParamHandler: Subscription;
    private dialogTitle: String = '';
    private canChangeNetworkType: boolean = true;
    private openIpScopeForEdit: boolean = false;
    private ipScopeDialogTitle: String = 'Add IP Scope';
    private isNetworkCallInProgress: boolean = false;
    private networkOperationFailed: boolean = false;
    private errorMessage: string = '';
    private tableSettings: Object = {};
    private tableConfig: Object = {};
    private titleForOKButton: string = 'ADD';
    private canEditGatewayIP: boolean = true;
    private copyOfNwToVerify: any;
    private ipScopeOKBtnText: string = 'ADD';
    private vcList: Array<any> = [];
    private selectedVCForBacking: any[] = [];
    private backingList: {};
    private backingSelectedRows: any;
    private vcAssociation: {};
    @ViewChild('ipscopeGrid') ipscopeGrid: VcaGrid;
    private openAssociateVcDialog: boolean = false;
    private selectedDvpgVw: Array<any>;
    private vcId: string = '';
    private isLoading: boolean = false;
    private isEdit: boolean = false;
    private processedVCList: Array<any> = [];
    private canAddIPScopes: boolean = true;
    private networkType: string = '';
    private isEnterpriseAdmin: boolean = false;
    private isDCEnterpriseAdmin: boolean = false;
    private canSelectVirtualWire: boolean = false;
    constructor(private networkService: NetworkService,
            private router: Router,
            private alert: VcaAlertsService,
            private activatedRoute: ActivatedRoute,
            private translate: TranslateService,
            public authService: AuthService) {
        this.tableConfig = getIPScopeListingDatatableConfig();
        Object.assign(this.tableSettings, this.tableConfig, { 'data': [] });
        translate.use(GlobalVariables.LOCALE);

        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];

        if (_.includes(roles, 'Enterprise Administrator')) {
            this.isEnterpriseAdmin = true;
        }
        this.canSelectVirtualWire = false;
    }

    ngOnChanges() {
    }

    resetData() {
        this.dataModel = {
            ipScopes: [],
            name: '',
            description: '',
            l3TenantManaged: true, // Internet = false, DC = true, Other NW true
            ownedBySystem: true, // Internet & DC = true, other NW false
            allowTrunkInterfaces: false,
            enterprise: 'DEFAULT',
            backings: []
        };

        this.vcAssociation = {};
        this.backingSelectedRows = {};
        this.selectedVCForBacking = [];
        this.vcList = [];
        this.processedVCList = [];
    }

    ngOnInit() {
        this.resetData();
        this.networkTypes.push({
            value: NetworkConstants.NETWORK_VALUES.TRANSIT,
            label: NetworkConstants.NETWORK_NAMES.TRANSIT
        });
        this.networkTypes.push({
            value: NetworkConstants.NETWORK_VALUES.COMPUTE,
            label: NetworkConstants.NETWORK_NAMES.COMPUTE
        });

        this.subscribeParamHandler = this.activatedRoute.params.subscribe(params => {
            let id = params['id'];
            if (id) {
                this.isEdit = true;
                this.getNetwork(id);
                this.dialogTitle = this.translate.instant('vcNetwork.editNW');;
                this.titleForOKButton = 'SAVE';
                this.operationMode = NetworkConstants.OPERATION_MODE.EDIT;
                this.canChangeNetworkType = false;
            } else {
                this.dialogTitle = this.translate.instant('vcNetwork.importNW');
            }
        });
        this.getAllVCs();
        this.getComputeContainers();
    }

    cancel() {
        this.onCancel.emit();
        if(this.routeOnCompleteOrCancel) {
            this.router.navigate([this.routeTo]);
        } else {
            this.showModal = false;
        }
    }

    // Add
    importNetwork() {
        this.isNetworkCallInProgress = true;
        this.networkOperationFailed = false;
        this.dataModel.backings = this.getNetworkBackings();
        let payload = _.cloneDeep(this.dataModel);

        if (this.networkType === 'TrunkInterfaces') {
            if (typeof payload['ipScopes'] !== "undefined") {
                delete payload['ipScopes'];
            }
            if (typeof payload['l3TenantManaged'] !== "undefined") {
                delete payload['l3TenantManaged']
            }
        }

        if (this.operationMode === NetworkConstants.OPERATION_MODE.ADD) {
            this.subscribeHandler = this.networkService.createNetworkAdmin(payload)
                .subscribe(
                networks => {
                    this.isNetworkCallInProgress = false;
                    this.networkService.getAllNetworks();
                    this.onComplete.emit();
                    if(this.routeOnCompleteOrCancel) {
                        this.router.navigate([this.routeTo]);
                    } else {
                        this.showModal = false;
                    }
                },
                error => this.handleNetworkOpreationError(error),
                () => this.logOperationCompleted('create network operation completed')
                );
        } else {
            this.subscribeHandler = this.networkService.updateNetwork(this.dataModel)
                .subscribe(
                networks => {
                    this.isNetworkCallInProgress = false;
                    this.networkService.getAllNetworks();
                    this.onComplete.emit();
                    if(this.routeOnCompleteOrCancel) {
                        this.router.navigate([this.routeTo]);
                    } else {
                        this.showModal = false;
                    }
                },
                error => this.handleNetworkOpreationError(error),
                () => this.logOperationCompleted('create network operation completed')
                );
        }
    }

    getNetwork(networkId) {
        let me = this;
        this.subscribeHandler = this.networkService.getNetwork(networkId)
            .subscribe(
            (network: any) => {
                this.dataModel = network;
                this.copyOfNwToVerify = _.cloneDeep(network);
                if (this.isEnterpriseAdmin && this.dataModel.l3TenantManaged && this.dataModel.ownedBySystem) {
                    this.isDCEnterpriseAdmin = true;
                }
                this.assignNetworkType();
                this.associateBackingsToVC();
            },
            error => this.logError(error, 'get network operation failed'),
            () => this.logOperationCompleted('get network operation completed')
            );
    }


    onIpScopeCreate() {
        this.canEditGatewayIP = true;
        this.ipScopeDialogTitle = 'Add IP Scope';
        this.ipScopeOKBtnText = 'ADD';
        this.openIpScopeForEdit = false;
        this.selectedIpScope = { gateway: '', networkIpRanges: [{}] };
        this.openIPScopeDialog = true;
    }

    onIpScopeEdit() {
        if (this.operationMode === NetworkConstants.OPERATION_MODE.EDIT) {
            if (this.isIpScopeExistsInCollection(this.copyOfNwToVerify.ipScopes, this.selectedIpScope) !== -1) {
                this.canEditGatewayIP = false;
            } else {
                this.canEditGatewayIP = true;
            }
        }
        this.ipScopeOKBtnText = 'SAVE';
        this.ipScopeDialogTitle = 'Edit IP Scope';
        this.openIpScopeForEdit = true;
        this.openIPScopeDialog = true;
    }

    onIPScopeSelected(event) {
        this.isRowSelected = true;
        if (event && event.value && event.value instanceof Array) {
            if (event.value[0]) {
                this.selectedIpScope = _.cloneDeep(event.value[0]);
                this.selectedIPScopeRowIndex = this.isIpScopeExistsInCollection(this.dataModel.ipScopes, event.value[0]);
                this.isRowSelected = true;
            } else {
                this.selectedIpScope = { gateway: '', networkIpRanges: [{}] };
                this.isRowSelected = false;
                this.selectedIPScopeRowIndex = -1;
            }
        }
    }

    onIpScopeDelete(event) {
        if (this.selectedIPScopeRowIndex !== -1) {
            let index: number = this.isIpScopeExistsInCollection(this.dataModel.ipScopes, this.selectedIpScope);
            this.dataModel.ipScopes.splice(index, 1);
            this.dataModel.ipScopes = [].concat(this.dataModel.ipScopes);
            if (this.operationMode === NetworkConstants.OPERATION_MODE.EDIT) {
                let index: number = this.isIpScopeExistsInCollection(this.copyOfNwToVerify.ipScopes, this.selectedIpScope);
                if (index !== -1) {
                    this.copyOfNwToVerify.ipScopes.splice(this.selectedIPScopeRowIndex, index);
                }
            }
        }
    }

    getComputeContainers() {
        this.subscribeHandler = this.networkService.getComputeContainer()
            .subscribe(
            (containers:any) => {
                this.computeContainers = containers;
                this.showModal = true;
            },
            error => this.logError(error, 'get all networks'),
            () => this.logOperationCompleted('get all networks')
            );
    }

    onDialogClose(event) {
        if (!event) {
            this.cancel();
        }
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

    handleNetworkOpreationError(error: any) {
        this.networkOperationFailed = true;
        this.isNetworkCallInProgress = false;
        this.errorMessage = error.errorMessage;
    }

    isIpScopeExistsInCollection(collection, ipScope): number {
        let objectToCompare = {
            'prefixLength' : ipScope.prefixLength,
            'networkIpRanges': ipScope.networkIpRanges
        };
        // As Gateway is optional now
        if (ipScope.gateway) {
            objectToCompare['gateway'] = ipScope.gateway;
        }
        let index = _.findIndex(collection, objectToCompare);
        return index;
    }

    onIpScopeDialogSave(event) {
        this.openIPScopeDialog = false;
        if (this.openIpScopeForEdit) {
            this.dataModel.ipScopes[this.selectedIPScopeRowIndex] = event.ipScope;
        } else {
            if (typeof this.dataModel.ipScopes === "undefined") {
                this.dataModel.ipScopes = [];
            }
            this.dataModel.ipScopes.push(event.ipScope);
        }
        this.dataModel.ipScopes = [].concat(this.dataModel.ipScopes);
        this.isRowSelected = false;
        this.selectedIPScopeRowIndex = -1;
    }

    onIpScopeDialogClosed(event) {
        this.openIPScopeDialog = false;
        this.ipscopeGrid.deselectRow();
    }

    setNetworkType(type: string) {
        this.networkType = type;
        let dm = this.dataModel;
        if (type === 'Internet') {
            dm.l3TenantManaged = false;
            dm.allowTrunkInterfaces = false;
            this.canAddIPScopes = true;
            this.canSelectVirtualWire = true;
            return;
        }
        if (type === 'DirectConnect') {
            dm.l3TenantManaged = true;
            dm.allowTrunkInterfaces = false;
            this.canAddIPScopes = true;
            this.canSelectVirtualWire = true;
            return;
        }
        if (type === 'TrunkInterfaces') {
            dm.l3TenantManaged = false;
            dm.allowTrunkInterfaces = true;
            this.dataModel.ipScopes = [];
            this.canAddIPScopes = false;
            this.canSelectVirtualWire = false;
        }
    }

    assignNetworkType() {
        let dm = this.dataModel;
        if (dm.allowTrunkInterfaces) {
           this.networkType = 'TrunkInterfaces';
           this.canAddIPScopes = false;
           this.canSelectVirtualWire = false;
           return;
        } else if (dm.l3TenantManaged) {
            this.networkType = 'DirectConnect';
        } else {
            this.networkType = 'Internet';
        }
        this.canSelectVirtualWire = true;
        this.canAddIPScopes = true;
    }

    isFormValid() {
        let dm = this.dataModel;
        let isBackings: boolean = false;
        this.processedVCList.forEach(function(vc) {
            if (vc['backings']['dvpgs'].length > 0 || vc['backings']['virtualwires'].length > 0) {
                isBackings = true;
            }
        })
        if (dm.name && isBackings) {
            return true;
        }
        return false;
    }

    isSelectLinkVisible(vcenter_instanceId: string) {
        if (vcenter_instanceId && this.selectedVCForBacking.length > 0 && this.selectedVCForBacking.indexOf(vcenter_instanceId) >= 0) {
            return true;
        }
        return false;
    }

    onAssociateVcDialogClosed(event) {
        this.openAssociateVcDialog = false;
    }

    onAssociateVcDialogSave(event) {
        this.openAssociateVcDialog = false;
        this.processedVCList.forEach(function(vc) {
            if (event.vcId === vc.vcenter_instanceId) {
                vc.backings.dvpgs = event.selectedDVPG;
                vc.backings.virtualwires = event.selectedVirtualWire;
            }
        });
    }

    selectBackings(vcId: string = '') {
        this.vcId = vcId;
        this.backingSelectedRows = typeof this.vcAssociation[vcId] !== 'undefined' ? this.vcAssociation[vcId] : [];
        this.openAssociateVcDialog = true;
    }

    removeBackings(vcId: string = '') {
        this.processedVCList.forEach(function(vc) {
            if (vcId === vc.vcenter_instanceId) {
                vc.backings.dvpgs = [];
                vc.backings.virtualwires = [];
            }
        });
    }

    getAllVCs() {
        this.vcList = [];
        this.isLoading = true;
        this.networkService.getVcList()
        .subscribe(
        (data: any) => {
            this.vcList = data;
            this.isLoading = false;
            this.processedVCList = _.cloneDeep(this.vcList);
            this.processedVCList.forEach(function(obj) {
                obj.backings = {'dvpgs': [], 'virtualwires': []};
            });
            if (this.isEdit) {
                this.associateBackingsToVC();
            }
        },
        error => {
            this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
            this.isLoading = false;
        }
        );
    }

    associateBackingsToVC() {
        if (!this.processedVCList || !this.dataModel || !this.dataModel.backings || this.dataModel.backings.length === 0) {
            return;
        }
        var __this = this;
        var selectedIds = [];
        if (this.dataModel && this.dataModel.backings.length > 0) {
            this.processedVCList.forEach(function(vc) {
                __this.dataModel.backings.forEach(function(backing) {
                    if (vc.vcenter_instanceId === backing.vCenterInstanceUuid) {
                        if (selectedIds.indexOf(backing.vCenterInstanceUuid) === -1) {
                            selectedIds.push(backing.vCenterInstanceUuid);
                        }
                        if (backing.backingId.indexOf('dvportgroup') >= 0) {
                           vc['backings']['dvpgs'].push ({'entity_id': backing.backingId, 'name': backing.backingName});
                        } else {
                            vc['backings']['virtualwires'].push ({'objectId':backing.backingId, 'name': backing.backingName});
                        }
                    }
                });
            });
        }
    }

    getNetworkBackings() {
        let __this = this;
        let backings = [];
        this.processedVCList.forEach(function(vc) {
            let dvpgs = vc['backings']['dvpgs'];
            let virtualWires = vc['backings']['virtualwires'];
            if (dvpgs[0] && dvpgs[0]['entity_id']) {
                backings.push({'backingId': dvpgs[0]['entity_id'], 'vCenterInstanceUuid': vc['vcenter_instanceId']});
            }
            if (__this.networkType !== 'TrunkInterfaces') {
                if (virtualWires[0] && virtualWires[0]['objectId']) {
                    backings.push({'backingId': virtualWires[0]['objectId'], 'vCenterInstanceUuid':vc['vcenter_instanceId']});
                }
            }
        });
        return backings;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/import-network/add-edit-import-network-dialog.component.ts